// extracted by mini-css-extract-plugin
module.exports = {"btn":"ConfirmButton_btn__3Cx-f","btnDisabled":"ConfirmButton_btnDisabled__3Sr9u"};